// Environment configuration for security
export const ENV_CONFIG = {
  // Firebase Configuration
  FIREBASE: {
    API_KEY: process.env.REACT_APP_FIREBASE_API_KEY ,
    AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ,
    DATABASE_URL: process.env.REACT_APP_FIREBASE_DATABASE_URL ,
    PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID ,
    STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ,
    MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ,
    APP_ID: process.env.REACT_APP_FIREBASE_APP_ID 
  },
  
  // Security Configuration
  SECURITY: {
    SESSION_TIMEOUT: parseInt(process.env.REACT_APP_SESSION_TIMEOUT) , // 30 minutes
    MAX_LOGIN_ATTEMPTS: parseInt(process.env.REACT_APP_MAX_LOGIN_ATTEMPTS) ,
    RATE_LIMIT_WINDOW: parseInt(process.env.REACT_APP_RATE_LIMIT_WINDOW) , // 5 minutes
    DEVICE_NAME_REGEX: /^[a-zA-Z0-9\s\-_]{3,20}$/,
    PASSWORD_MIN_LENGTH: 6
  }
};


